import React, { Component } from 'react'
import PopupWindow from './PopupWindow'
import { connect } from 'react-redux';
import * as ChatActions from '../../actions/chatActions';
import * as StatisticActions from '../../actions/statisticActions';
import { bindActionCreators } from 'redux';
import Checkbox from './Checkbox'
import StatsBaseWindow from './StatsBaseWindow'
import io from 'socket.io-client'
import ChannelList from './ChatComponents/ChannelList'
import MessageList from './ChatComponents/MessageList'
import UserList from './ChatComponents/UserList'
import SendMessage from './ChatComponents/SendMessage'

class ChatWindow extends StatsBaseWindow {

    static propTypes = {
        top: React.PropTypes.number,
        left: React.PropTypes.number
    }

    static defaultProps = {
        top: 10,
        left: 10
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.clientSocket = io.connect('http://localhost:5000');
        this.clientSocket.on('message', msg => console.log(msg));
        this.clientSocket.on('connected', msg => {
            this.props.ChatActions.connectToChatAs(msg.userName);
            this.props.ChatActions.updateChannels(msg.channels);
        })
        this.clientSocket.on('channelChanged', msg => {
            this.props.ChatActions.change_channel(msg.Id)
        });
    }

    onChannelSelectClick(channelId) {
        console.log('onChannelSelectClick');
        this.clientSocket.emit('changeChannel', { id: channelId });
    }

    render() {
        const { close_stats_window } = this.props.StatisticActions;
        
        return (<PopupWindow header="Чат" is_cut_down={this.props.is_cut_down} onDragStop={this.onDragStop.bind(this)} onToggleCutDown={this.onToggleCutDown.bind(this)} top={this.position.top}  left={this.position.left} onClose={() => (close_stats_window(this.props.id))}>
                    {
                        this.props.connected == true &&
                            <div className="row chat">
                                <div className="row">
                                     <span>connected as {this.props.userName}</span>
                                </div>
                                <div className="col-md-8">
                                    <div className="row">
                                        <MessageList messages={this.props.messages}/>
                                    </div>
                                    <div className="row">
                                        <SendMessage/>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="row">
                                        <ChannelList channels={this.props.channels} selectChannel={this.onChannelSelectClick.bind(this)} selectedChannelId={this.props.selectedChannelId}/>
                                    </div>
                                    <div className="row">
                                        <UserList users={this.props.users}/>
                                    </div>
                                </div>
                            </div>
                    }
                    {
                        this.props.connected == false &&
                            <span>connecting</span>
                    }
                </PopupWindow>)
    }
}

function mapStateToProps(state, ownProps) {
    return {
        position: state.statisticWindows.chat.position,
        is_cut_down: state.statisticWindows.chat.is_cut_down,
        userName: state.chat.userName,
        connected: state.chat.connected,
        users: state.chat.users,
        messages: state.chat.messages,
        channels: state.chat.channels,
        selectedChannelId: state.chat.selectedChannelId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        ChatActions: bindActionCreators(ChatActions, dispatch),
        StatisticActions: bindActionCreators(StatisticActions, dispatch),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatWindow)



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/ChatWindow.js
 **/